import Fahi from '../../assets/testimonials-images/fahi.jpeg'
import SaintAntonin from '../../assets/testimonials-images/saint-antonin.jpeg'
import Thilliez from '../../assets/testimonials-images/thilliez.jpeg'

export const testimonialsData = [
  {
    name: 'Hamza Fahi',
    position: 'Engineer Product Manager',
    img: Fahi,
    review: 'J’ai mentoré Hamza sur le parcours développeur Javascript react d’openclassrooms, Hamza à acquis de solides compétences en matière de l’intégration web, programmation web et la gestion de projet agile. Il s’est investi avec un grand professionnalisme dans l’ensemble des projets.'
  },
  {
    name: 'Thomas Saint-Antonin',
    position: 'Journaliste finance',
    img: SaintAntonin,
    review: 'Hamza est un élément essentiel dans un groupe de travail. Calme, serein et perfectionniste, il a toujours proposé des livrables de qualité lorsque nous avons travaillé ensemble. Ses qualités rédactionnelles et sa curiosité sont également à mettre en avant. Il est un des éléments sur lesquels vous pouvez vous appuyer lors de projets.'
  },
  {
    name: 'Isabelle Thilliez',
    position: 'Formatrice en communication, marketing et soft skills',
    img: Thilliez,
    review: `Hamza est sérieux et créatif, engagé dans ce qu'il fait et doté d'un fort potentiel.
    Je le recommande vivement.`
  }
]